function convertMilesToFeet(num) {
  let eq =
    "Converting " + num + " miles to feet: \n" + num + " * 5280 = ";
  let rep = num * 5280;
  return eq + rep.toFixed(2);
}

function convertMilesToInches(num) {
  let eq =
    "Converting " +
    num +
    " miles to inches: \n" +
    num +
    " * 63360 = ";
  let rep = num * 63360;
  return eq + rep.toFixed(2);
}

function convertMilesToYards(num) {
  let eq =
    "Converting " +
    num +
    " miles to yards: \n" +
    num +
    " * 1760 = ";
  let rep = num * 1760;
  return eq + rep.toFixed(2);
}

function convertMilesToMeters(num) {
  let eq =
    "Converting " +
    num +
    " miles to meters: \n" +
    num +
    " / 0.00062137 = ";
  let rep = num / 0.00062137;
  return eq + rep.toFixed(3);
}

function convertMilesToCM(num) {
  let eq =
    "Converting " +
    num +
    " miles to centimeters: \n" +
    num +
    " / 0.0000062137 = ";
  let rep = num / 0.0000062137;
  return eq + rep.toFixed(3);
}

function convertMilesToKilometers(num) {
  let eq =
    "Converting " +
    num +
    " miles to kilometers: \n" +
    num +
    " / 0.62137 = ";
  let rep = num / 0.62137;
  return eq + rep.toFixed(3);
}

export {
  convertMilesToFeet,
  convertMilesToInches,
  convertMilesToYards,
  convertMilesToMeters,
  convertMilesToCM,
  convertMilesToKilometers
};
